import { Button, Image, OverlayTrigger, Tooltip } from "react-bootstrap";
import {
  blackInfo,
  editBtn,
} from "../../../assets/images/images";
import { NUMBERS } from "../../../resources/number-constants";
import { useState } from "react";

const JDField = ({
  title,
  field,
  renderData,
  handleEdit,
  nearPeer,
  fetchNPRanking,
  showEdit = true,
  showNearPear = true,
  showLoader = false,
}: any) => {
  const [showCreateTooltip, setShowCreateTooltip] = useState(false);

  const handleEditJob = () => {
    if (showLoader) {
      setShowCreateTooltip(true);
      setTimeout(() => setShowCreateTooltip(false), 3000);
      return;
    }
    handleEdit(renderData, field);
  };

  const renderButton = () => {
    return (
      <OverlayTrigger placement="top" overlay={<Tooltip>Edit</Tooltip>}>
        <div className="render-btn-flex">
          <Image
            src={editBtn}
            height={12}
            width={12}
            alt="arrow"
            className="brown-arrow"
          />
          <Image
            src={editBtn}
            height={12}
            width={12}
            alt="arrow"
            className="white-arrow d-none"
          />
        </div>
      </OverlayTrigger>
    );
  };

  return (
    <>
      <div className="scroll-container no-scroll">
        <div className="content">
          <div className="title-with-text">
            {field !== "distance" && <h4>{title}</h4>}
            {field === "distance" && (
              <h4 className="align-items-center d-flex">
                {title}
                <OverlayTrigger
                  placement="top"
                  overlay={
                    <Tooltip>
                      Distances are calculated using your office location to
                      ensure precision.
                    </Tooltip>
                  }
                >
                  <div className="info-icon ms-1">
                    <Image src={blackInfo} height={20} width={20} alt="Info" />
                  </div>
                </OverlayTrigger>
              </h4>
            )}
            {showNearPear && (
              <Button
                variant="primary"
                className="regenerate-btn"
                onClick={fetchNPRanking}
              >
                {nearPeer ? "Regenerate" : "Generate Near Peer Ranking"}
              </Button>
            )}
            {nearPeer && (
              <div
                className={`text ${nearPeer > NUMBERS.FIFTY ? "text-green" : "text-danger"}`}
              >
                <span className="text-ranking">Near Peer Ranking:</span>
                {nearPeer}%
              </div>
            )}
          </div>
          <div
            className="text-description"
            dangerouslySetInnerHTML={{ __html: renderData }}
          />
        </div>
        {showEdit && (
          <div className="bottom-btn">
            <OverlayTrigger
              placement="top"
              show={showCreateTooltip}
              overlay={
                <Tooltip id="tooltip-limit">
                  Please wait! Job Description is updating...
                </Tooltip>
              }
            >
              <Button variant="light" onClick={handleEditJob}>
                {renderButton()}
              </Button>
            </OverlayTrigger>
          </div>
        )}
      </div>
    </>
  );
};

export default JDField;
